module.exports = __webpack_public_path__ + "static/media/frame-home.1bbd33e4.png";